import L from 'leaflet'
import { getAuthHeader } from '@/utils/Helpers'
import store from '@/store'

const floorsTimestamp = {}

const getFloorTimestampMark = () => {
  let floorId = store.state.map.floorId
  if (!floorsTimestamp[floorId]) {
    floorsTimestamp[floorId] = encodeURI(store.getters['floor/getFloorMapUpdatedAt'](floorId))
  }

  return floorsTimestamp[floorId]
}

export default L.TileLayer.extend({
  options: {
    minZoom: 17,
    maxZoom: 23
  },
  getTileUrl: (coordinates) => {
    const { z, x, y } = coordinates
    return `${window.location.origin}/api/v1/maps/${
      store.state.map.floorId
    }/Z${z.toString()}/${y.toString()}_${x.toString()}.png?t=${getFloorTimestampMark()}`
  },
  createTile(coords, done) {
    const tile = document.createElement('img')

    let xhr = new XMLHttpRequest()
    xhr.onloadstart = function() {
      xhr.responseType = 'blob'
    }

    xhr.addEventListener('loadend', function(evt) {
      const data = this.response
      if (data?.type === 'image/png') {
        tile.src = URL.createObjectURL(data) // todo: add revoke or fileloader
      } else {
        tile.src = '/img/blank3.png'
      }
      done(null, tile)
    })
    xhr.addEventListener('error', function() {
      console.error('[map] tile error')
      tile.src = '/img/blank3.png'
    })
    xhr.open('GET', this.getTileUrl(coords))
    let authHeader = getAuthHeader()
    xhr.setRequestHeader('Authorization', authHeader.Authorization)
    xhr.send()

    return tile
  }
})
